import { useEffect, useRef, useState} from 'react';
import './OffersDisplay.css';
import LoadingAnimation from '../LoadingAnimation/LoadingAnimation';
import { BsWrench } from 'react-icons/bs';
import SingleOffer from '../SingleOffer/SingleOffer';
import { Wrapper } from "@googlemaps/react-wrapper";
import { GoogleMap, useMap } from "googlemaps-react-primitives";
import Marker from '../Map/Marker/Marker';
import MultipleOffersMarker from '../Map/MultipleOffersMarker/MultipleOffersMarker';
import { useMainFilter, useSecondFilter, useDownloadedOffers, useOffersToDisplay, useSearchInputValue, useDetailedOffer, useOpenedOfferIndex, useMobileMapView, useExperienceFilter, useCountryFilter, useDispla } from '../../data/GlobalStates';
import { useAtom } from 'jotai';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';


const OffersDisplay = ({setRefresh}) => {

  const scrolledOffer = useRef(null);
  const containerRef = useRef(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const openedOfferId = params.get('openedOfferId') || location.state?.openedOfferId;



  //stany globalne:
  const [ MainFilter, setMainFilter ] = useAtom(useMainFilter);
  const [ SecondFilter, setSecondFilter ] = useAtom(useSecondFilter);
  const [ ExperienceFilter, setExperienceFilter ] = useAtom(useExperienceFilter);
  const [ DownloadedOffers, setDownloadedOffers ] = useAtom(useDownloadedOffers);
  const [ OffersToDisplay, setOffersToDisplay ] = useAtom(useOffersToDisplay);
  const [ SearchInputValue, setSearchInputValue ] = useAtom(useSearchInputValue);
  const [ DetailedOffer, setDetailedOffer] = useAtom(useDetailedOffer);
  const [ OpenedOfferIndex, setOpenedOfferIndex] = useAtom(useOpenedOfferIndex);
  const [ MobileMapView, setMobileMapView] = useAtom(useMobileMapView);
  const [ CountryFilter, setCountryFilter] = useAtom(useCountryFilter);


  //stany lokalne:
  const [ mapCenterLong, setMapCenterLong ] = useState(21)
  const [ mapCenterLat, setMapCenterLat] = useState(51)
  const [ mapZoomLevel, setmapZoomLevel] = useState(6)



  const render = (status) => {
    if (status !== status.success) {
      return <LoadingAnimation />
    }
  };


  const ZoomLevelDisplay = () => {
  const map = useMap()

  useEffect(() => {
    if (!map) return
    const handleZoomChanged = () => {
      const currentZoom = map.getZoom()
      setmapZoomLevel(currentZoom)
    }
    map.addListener("zoom_changed", handleZoomChanged);
  }, [map])

  return null
};



   useEffect(() => {
      const handleScroll = () => { 

       const element = document.querySelectorAll('p.SingleOfferTitle')[OpenedOfferIndex]
       
        if (element && OpenedOfferIndex) {
          element.scrollIntoView({ behavior: 'auto' });
        }
      } 
      handleScroll()
  }, [DetailedOffer]);


useEffect(() => {
  if (MobileMapView) {
    const mobileMap = document.querySelector('.MobileMapMainContainer');
    if (mobileMap) {
      setTimeout(() => {
        mobileMap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }
  }
}, [MobileMapView]);

 
  const ShowLoadingOrEmptyDataFilter = () => { 
    if (!DownloadedOffers.length) {
      return (
          <div>
            <LoadingAnimation />
          </div>
      )
    } else if (!OffersToDisplay.length && !MainFilter && SearchInputValue) {
      return (
        <div className='NoOffersInfoMessageContainer'>
         <h1 id='NoOffersInfoHeader'>Nie znaleziono ofert wg. wyszukiwanych słów:</h1>
         {SearchInputValue.length < 33 ? <h1 id='NoOffersInfo'>{SearchInputValue}</h1> : <h1 id='NoOffersInfo'>{`${SearchInputValue.slice(0,32) + '...'}`}</h1>}
         <BsWrench className='NoOffersInfoAnimation'/>
        </div>
      )
    } else if (!OffersToDisplay.length && MainFilter && !SecondFilter) { 
     return (
      <div className='NoOffersInfoMessageContainer'>
           <h1 id='NoOffersInfoHeader'>Brak ofert w kategorii:</h1> 
           <h1 id='NoOffersInfo'>{MainFilter}</h1>
           {ExperienceFilter ? <h1 id='NoOffersInfo'>{ExperienceFilter}</h1> : ''}
           <BsWrench className='NoOffersInfoAnimation'/>
           {CountryFilter? <h1 id='NoOffersInfo'>{CountryFilter}</h1> : ''}
      </div>
      )
    } else if (!OffersToDisplay.length && MainFilter && SecondFilter) {
      return (
        <div className='NoOffersInfoMessageContainer'>
             <h1 id='NoOffersInfoHeader'>Brak ofert w kategorii:</h1>
             <h1 id='NoOffersInfo'>{MainFilter}</h1>
             <h1 id='NoOffersInfo'>{SecondFilter}</h1>
             <BsWrench className='NoOffersInfoAnimation'/>
             {CountryFilter? <h1 id='NoOffersInfo'>{CountryFilter}</h1> : ''}
        </div>
        )
    } else if (!OffersToDisplay.length && !MainFilter && !SecondFilter && ExperienceFilter) {
      return (
        <div className='NoOffersInfoMessageContainer'>
             <h1 id='NoOffersInfoHeader'>Brak ofert w kategorii:</h1>
              {ExperienceFilter ? <h1 id='NoOffersInfo'>{ExperienceFilter}</h1> : ''}
              <BsWrench className='NoOffersInfoAnimation'/>
              {CountryFilter? <h1 id='NoOffersInfo'>{CountryFilter}</h1> : ''}
        </div>
        )
    }
   };


   const memoizedMarkers = useMemo(() => {
   const offersFromSameCity = [];
   const offersWithCity = OffersToDisplay.filter(
    offer => Number(offer.cityLatit) !== 0 && offer.cityLatit !== null && offer.cityLatit !== undefined
  );

  const activeCities = offersWithCity.map(o => o.city);

  return offersWithCity.map((offer) => {
    const occurrences = activeCities.filter(city => city === offer.city).length;

    if (occurrences < 2) {
      return (
        <Marker
          position={{ lat: Number(offer.cityLatit), lng: Number(offer.cityLong) }}
          key={offer.id}
          offer={offer}
          mapZoomLevel={mapZoomLevel}
        />
      );
    } else {
      offersFromSameCity.push(offer);
      return (
        <MultipleOffersMarker
          position={{ lat: Number(offer.cityLatit), lng: Number(offer.cityLong) }}
          key={offer.id}
          offersFromSameCity={offersFromSameCity}
          offer={offer}
          setMapCenterLat={setMapCenterLat}
          setMapCenterLong={setMapCenterLong}
          mapZoomLevel={mapZoomLevel}
          setmapZoomLevel={setmapZoomLevel}
        />
      );
    }
  });
}, [OffersToDisplay, mapZoomLevel]);

   const switchMobileView = () => {
    setMobileMapView(!MobileMapView)
   };


   const mobileViewSwitch = () => {
    if (!MobileMapView) {
      return (
        <div id='OffersAndMapContainer'> 

           
         <div className='OffersDisplayScrollableContainer' ref={containerRef}>  
            {OffersToDisplay.length ? OffersToDisplay.map((offer, index) => (
              <SingleOffer
                 key={offer.id}
                 offer={offer}
                 setDetailedOffer={setDetailedOffer}
                 setRefresh={setRefresh}
                 scrolledOffer={scrolledOffer}
                 dataIndex={index}
                 id={`offer-${index}`}
                 />))
                : ShowLoadingOrEmptyDataFilter()} 
    </div>
       <div className='MapMainContainer'>
          <Wrapper apiKey={process.env.REACT_APP_MAPSKEY} render={render} options={{streetViewControl:false}}>
            <GoogleMap  className='Map' center={{lat:mapCenterLat, lng:mapCenterLong}} zoom={mapZoomLevel} mapTypeControl={false} options={{streetViewControl: false, zoomControl:false}}>
             { OffersToDisplay.length ? memoizedMarkers : '' }
            <ZoomLevelDisplay/>
           </GoogleMap>
          </Wrapper>
    </div>
</div>
      )
    } else if (MobileMapView) {
       return (
        <div className='MobileMapMainContainer'>
          <Wrapper apiKey={process.env.REACT_APP_MAPSKEY} render={render}>
            <GoogleMap  className='MobileMap' center={{lat:mapCenterLat, lng:mapCenterLong}} zoom={mapZoomLevel} options={{streetViewControl: false, zoomControl:false}} mapTypeControl={false}>
             { OffersToDisplay.length ? memoizedMarkers : '' }
           <ZoomLevelDisplay/>
          </GoogleMap>
         </Wrapper>
       </div>
       )
    }
   };

    return (
    <div className='OffersDisplayMainContainer'> 
      {mobileViewSwitch()}
    </div>
    )
};
export default OffersDisplay;


